import { GoogleAnalyticsEscriptEventName } from '@/hooks/analytics/types';
import useGoogleAnalytics from '@/hooks/analytics/useGoogleAnalytics';
import { hashedEmail } from '@/hooks/analytics/utils';
import { usePreOnboardingContext } from '@/hooks/escript/usePreOnboardingContext';
import { emitUIEvent } from '@montugroup/data-collection';
import { Divider, Typography } from '@montugroup/design-system';
import { useEffect } from 'react';
import { ResendInviteButton } from '../ResendInviteButton';

export const ScriptValidOOS = () => {
  const { customerDetails } = usePreOnboardingContext();
  const { sendGoogleAnalyticsEvent } = useGoogleAnalytics();
  const meansOfContact = customerDetails?.phone ? 'mobile' : 'email';

  // todo: emitUIEvent is an interim approach until the data collection package is updated with 'Data Events' schema
  useEffect(() => {
    sendGoogleAnalyticsEvent(GoogleAnalyticsEscriptEventName.PRESCRIPTION_SUBMIT_COMPLETE, {
      sha_email: customerDetails?.email ? hashedEmail(customerDetails?.email) : '',
      stock: 'out of stock',
      product_match: 'validated',
    });
    emitUIEvent(
      {
        component_name: 'out_of_stock_screen',
        event_name: 'screenViewed',
        id: 'escript_onboarding_out_of_stock',
        value: 'out of stock screen viewed',
      },
      [],
    );
  }, []);

  return (
    <>
      <Typography variant="subtitle1" fontWeight={600} data-testid="out-of-stock-state">
        Sorry! While we do sell your medication, it is currently out of stock.
      </Typography>
      <Typography component="p">You can still signup with us using the link sent to your {meansOfContact}.</Typography>

      <Divider />
      <Typography variant="body2">
        Didn&apos;t get the invite? <ResendInviteButton />
      </Typography>
    </>
  );
};
